import {mutations} from "@/modules/MemberApp/store/mutations";
import {actions} from "@/modules/MemberApp/store/actions";
import {getters} from "@/modules/MemberApp/store/getters";

const state = {

    build: null,

    oauth: {
        access_token: null,
        expired_at: null,
        token_type: null,
    },
    config: {
        logo_url: null,
        support_email: null,
        url: null,
        translations: null,
        settings: null,
        google_tag: null,
    },

    account: null,
    accountExpires: null,

    availableProjects: null,
    availableProjectsExpires: null,

    questions: [],
    availableQuestions: null,
    availableQuestionsExpires: null,

    locale: null,

    rewards: [],
    rewardsExpire: null,

    redemptionHistory: null,
    redemptionHistoryExpires: null,

    activityHistory: null,
    activityHistoryExpires: null,

    authenticated: false,
    collectedData: null,
};

export default {
    namespaced: true,

    state,
    getters,
    actions,
    mutations
}

